import { Component, OnInit } from '@angular/core';
import { LabService } from '../lab.service';
import { UnprocessedImage } from '../types/lab.types';

@Component({
  selector: 'nw-lab-unprocessed',
  templateUrl: './unprocessed.component.html',
  styleUrls: ['./unprocessed.component.scss'],
})
export class LabUnprocessedComponent implements OnInit {
  unprocessedImages: UnprocessedImage[] = [];

  constructor(private lab: LabService) {}

  async ngOnInit(): Promise<void> {
    await this.loadImages();
  }

  async loadImages() {
    try {
      const unprocessed = await this.lab.getUnprocessedImages();
      this.unprocessedImages = unprocessed;
      console.log(this.unprocessedImages);
    } catch (error) {
      console.error(error);
    }
  }

  async onFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length < 1) {
      return;
    }

    await Promise.all(
      Array.from(input.files).map(file => this.lab.addImage(file)),
    );
    await this.loadImages();
  }

  async process(id: string) {
    await this.lab.processImage(id);
    await this.loadImages();
  }
}
